"use client";
// PersonalizationGate — anonim ISR içeriği ile skeleton arasındaki CSS geçidi.
//
// İkisini de DOM'a basar; hangisinin görüneceğine globals.css karar verir:
//
//   html.has-auth [data-hs="pending"] > [data-hs-skeleton] { display: block }
//   html.has-auth [data-hs="pending"] > [data-hs-body]     { akıştan çıkar,
//                                                            visibility:hidden }
//
// İçerik gizlenirken `display:none` KULLANILMIYOR: içeride Swiper var ve mount
// olurken kapsayıcı genişliğini ölçüyor; `display:none` içinde bu 0 çıkar ve
// carousel bozulur. Tam gerekçe globals.css'teki blokta.
//
// `has-auth` sınıfını <head>'deki bloklayıcı script ilk boyamadan ÖNCE ekliyor,
// dolayısıyla girişli kullanıcı anonim ürünleri hiç görmüyor — React'in
// hydration'ı beklenmiyor. Misafirde sınıf hiç eklenmediği için kurallar ölü:
// içerik anında görünür, skeleton boyanmaz. Tam gerekçe: authGateScript.ts.
//
// Neden ikisi birden basılıyor: sunucu kullanıcının girişli olup olmadığını
// bilemez (`cookies()` okumak route'u `ƒ` yapar ve kişisel yanıt paylaşılan
// cache'e yazılamaz), dolayısıyla ISR HTML'i iki ihtimali de taşımak zorunda.
//
// gateState "ready" olunca skeleton `null`'a düşüyor ama YERİ KORUNUYOR:
// children her zaman ikinci çocuk. Konum kaymasaydı React skeleton div'ini
// body div'i sanıp altındaki tüm ağacı yeniden kurardı (görseller yeniden
// decode edilirdi).
import { ReactNode } from "react";

interface PersonalizationGateProps {
  /**
   * false ise sarmalayıcı hiç basılmaz. ssrSection'dan türeyen sabit bir
   * değer olmalı — mount sonrası değişirse children yeniden mount olur.
   */
  enabled: boolean;
  state: "pending" | "ready";
  skeleton: ReactNode;
  children: ReactNode;
}

const PersonalizationGate = ({
  enabled,
  state,
  skeleton,
  children,
}: PersonalizationGateProps) => {
  if (!enabled) return <>{children}</>;

  return (
    <div data-hs={state}>
      {state === "pending" ? <div data-hs-skeleton="">{skeleton}</div> : null}
      <div data-hs-body="">{children}</div>
    </div>
  );
};

export default PersonalizationGate;
